import classNames from "classnames";
import { Icon, type IconProps } from "./Icon";
import { IconType } from "./IconType";

export interface Props extends Omit<IconProps, "type"> {
  isActive?: boolean;
}

export const ToggleIcon = ({ isActive, className, ...rest }: Props) => {
  return (
    <Icon
      type={isActive ? IconType.ChevronUp : IconType.ChevronDown}
      className={classNames(className, "d-flex")}
      {...rest}
    />
  );
};
